import { RouteRecordRaw } from 'vue-router';

const customerRoutes: RouteRecordRaw[] = [
	{
		path: '/konto/pomoc',
		redirect: '/konto/pomoc/subskrypcja',
	},
	{
		path: '/konto/pomoc/subskrypcja',
		name: 'QuickPaymentsPage',
		component: () => import('@customer/static-page/QuickPaymentsPage.vue'),
	},
	{
		path: '/konto/powiadomienia',
		name: 'PromoMessagesPage',
		component: () => import('@customer/global/PromoMessagesPage.vue'),
	},

];

export default customerRoutes;
